/**
 * v4.10.0 — Inline, lightweight helper line.
 *
 * Used inside modals (e.g. MyTap Access) where a full card is too heavy.
 * One short sentence + soft styling. Not dismissible — these are persistent
 * contextual reassurance lines, not onboarding cards.
 */
import { Info } from "lucide-react";

export const InlineHelper = ({ children, testId }) => {
    return (
        <p
            data-testid={testId}
            className="flex items-start gap-1.5 text-[12px] text-muted-foreground mt-1.5 mb-2"
        >
            <Info size={12} strokeWidth={1.75} className="flex-shrink-0 mt-0.5" style={{ color: "#0F766E" }} />
            <span>{children}</span>
        </p>
    );
};

export default InlineHelper;
